var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("main", [
    _c(
      "div",
      {
        staticClass: "bg-blue h-screen flex justify-center items-center",
        staticStyle: { "min-height": "840px" },
      },
      [
        _c("div", { staticClass: "signupcontainer" }, [
          _c(
            "div",
            { staticClass: "w-full flex flex-col items-center justify-center" },
            [
              !_vm.consentComapny && !_vm.consentTalent
                ? _c("JobBlissLogo", { staticClass: "logo" })
                : _vm._e(),
              _vm.companySignUp && _vm.comapnyIntital
                ? _c(
                    "div",
                    [
                      _c("h3", { staticClass: "welcomeText welcomeTextBig" }, [
                        _vm._v("Welcome to ProveraCare"),
                      ]),
                      _c(
                        "h5",
                        { staticClass: "subTextRegister text-center mb-4" },
                        [_vm._v(" Register your Company ")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass:
                            "text-base font-normal leading-6 font-outfit mb-4 text-center",
                        },
                        [
                          _vm._v(
                            " To get started please provide your business email "
                          ),
                        ]
                      ),
                      _c("ValidationObserver", {
                        staticClass: "flex flex-col overflow-hidden",
                        attrs: { tag: "div" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ invalid }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-col" },
                                    [
                                      _c("ValidationProvider", {
                                        staticClass: "w-full",
                                        attrs: {
                                          name: "Email address",
                                          rules:
                                            "c_email|required|is-email-registered",
                                          immediate: _vm.prepopulated,
                                          debounce: 500,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({
                                                errors,
                                                touched,
                                              }) {
                                                return [
                                                  _c("FormGroup", {
                                                    attrs: {
                                                      id: "username",
                                                      errorClass: "errorMargin",
                                                      name: "username",
                                                      type: "email",
                                                      inputClass:
                                                        "signwidthInput customSignText",
                                                      placeholder:
                                                        "email@businessname.com",
                                                      errors:
                                                        _vm.prepopulated ||
                                                        touched
                                                          ? errors
                                                          : [],
                                                      processing:
                                                        _vm.emailValidationPending,
                                                      isIcon: false,
                                                    },
                                                    model: {
                                                      value: _vm.email,
                                                      callback: function ($$v) {
                                                        _vm.email =
                                                          typeof $$v ===
                                                          "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                      },
                                                      expression: "email",
                                                    },
                                                  }),
                                                  _vm.regexError
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "regex-error",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.regexError
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "submit-wrapper mt-7" },
                                        [
                                          _c("UiButton", {
                                            attrs: {
                                              variant: "black",
                                              buttonClasses:
                                                "customPadding fontButton",
                                              disabled:
                                                invalid || _vm.euniceValidator,
                                              processing: _vm.loading,
                                              buttonText: "Continue",
                                            },
                                            on: {
                                              click: _vm.handleCompanyIntital,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2876463884
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.companySignUp && _vm.consentComapny && !_vm.comapnyIntital
                ? _c("div", { staticClass: "slideCompany slide-in-right" }, [
                    _c(
                      "h3",
                      {
                        staticClass:
                          "text-primary-black text-xl font-normal mb-4",
                      },
                      [_vm._v(" Consent Notice ")]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-sm font-normal mb-6 text-sm" },
                      [
                        _vm._v(
                          " By accessing or using the ProveraCare Site and services, you expressly consent to the collection, use, and disclosure of your personal and health information in accordance with our Privacy Policy and applicable laws. "
                        ),
                      ]
                    ),
                    _vm._m(0),
                    _c(
                      "div",
                      { staticClass: "flex items-start flex-col gap-2 mt-6" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "text-sm flex",
                            attrs: { for: "consentCheckbox" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.consentChecked,
                                  expression: "consentChecked",
                                },
                              ],
                              staticClass: "mt-1",
                              attrs: {
                                type: "checkbox",
                                id: "consentCheckbox",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.consentChecked)
                                  ? _vm._i(_vm.consentChecked, null) > -1
                                  : _vm.consentChecked,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.consentChecked,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.consentChecked = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.consentChecked = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.consentChecked = $$c
                                  }
                                },
                              },
                            }),
                            _c("span", { staticClass: "icon-checked" }, [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "11",
                                    height: "9",
                                    viewBox: "0 0 11 9",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                                      fill: "white",
                                      stroke: "white",
                                      "stroke-width": "0.3",
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _vm._m(1),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "submit-wrapper mt-6" },
                          [
                            _c("UiButton", {
                              attrs: {
                                variant: "black",
                                buttonClasses:
                                  "customPadding fontButtonConsent",
                                processing: _vm.loading,
                                disabled: !_vm.consentChecked || _vm.invalid,
                                buttonText: "Continue",
                              },
                              on: { click: _vm.handleSecondStepComapny },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.companySignUp && !_vm.consentComapny && !_vm.comapnyIntital
                ? _c(
                    "div",
                    { staticClass: "slideCompany slide-in-right" },
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "welcomeText welcomeTextSmall text-center",
                        },
                        [_vm._v(" Create your account ")]
                      ),
                      _c(
                        "h5",
                        { staticClass: "subTextRegister text-center mb-4" },
                        [
                          _vm._v(
                            " Just a few more things before you're ready! "
                          ),
                        ]
                      ),
                      _c("ValidationObserver", {
                        ref: "observer",
                        staticClass: "flex flex-col overflow-hidden",
                        attrs: { tag: "div" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ invalid, dirty, handleSubmit }) {
                                return [
                                  _c(
                                    "form",
                                    {
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                          return handleSubmit(_vm.submit)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-col customGap",
                                        },
                                        [
                                          _vm.companySignUp
                                            ? _c("ValidationProvider", {
                                                staticClass: "w-full",
                                                attrs: {
                                                  name: "Business name",
                                                  rules: "required|c_name",
                                                  immediate: _vm.prepopulated,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                        touched,
                                                      }) {
                                                        return [
                                                          _c("FormGroup", {
                                                            attrs: {
                                                              id: "business_name",
                                                              errorClass:
                                                                "errorMargin",
                                                              name: "Business name",
                                                              inputClass:
                                                                "signwidthInput customSignText",
                                                              placeholder:
                                                                "Business name",
                                                              errors:
                                                                _vm.prepopulated ||
                                                                touched
                                                                  ? errors
                                                                  : [],
                                                              isIcon: false,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.company
                                                                  .businessName,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.company,
                                                                    "businessName",
                                                                    typeof $$v ===
                                                                      "string"
                                                                      ? $$v.trim()
                                                                      : $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "company.businessName",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              })
                                            : _vm._e(),
                                          _c("ValidationProvider", {
                                            staticClass: "w-full",
                                            attrs: {
                                              name: "Preferred name",
                                              rules: "required|c_name",
                                              immediate: _vm.prepopulated,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({
                                                    errors,
                                                    touched,
                                                  }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        attrs: {
                                                          id: "givenName",
                                                          errorClass:
                                                            "errorMargin",
                                                          inputClass:
                                                            "signwidthInput customSignText",
                                                          name: "Preferred name",
                                                          placeholder:
                                                            "Preferred name",
                                                          errors:
                                                            _vm.prepopulated ||
                                                            touched
                                                              ? errors
                                                              : [],
                                                          isIcon: false,
                                                        },
                                                        model: {
                                                          value: _vm.givenName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.givenName =
                                                              typeof $$v ===
                                                              "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                          },
                                                          expression:
                                                            "givenName",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _c("ValidationProvider", {
                                            staticClass: "w-full",
                                            attrs: {
                                              name: "Last name",
                                              rules: "required|c_name",
                                              immediate: _vm.prepopulated,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({
                                                    errors,
                                                    touched,
                                                  }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        attrs: {
                                                          errorClass:
                                                            "errorMargin",
                                                          id: "familyName",
                                                          name: "Last name",
                                                          inputClass:
                                                            "signwidthInput customSignText",
                                                          placeholder:
                                                            "Last name",
                                                          errors:
                                                            _vm.prepopulated ||
                                                            touched
                                                              ? errors
                                                              : [],
                                                          isIcon: false,
                                                        },
                                                        model: {
                                                          value: _vm.familyName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.familyName =
                                                              typeof $$v ===
                                                              "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                          },
                                                          expression:
                                                            "familyName",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _c("ValidationProvider", {
                                            staticClass: "w-full",
                                            attrs: {
                                              name: "Password",
                                              rules: "password_len|required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({
                                                    errors,
                                                    touched,
                                                  }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        attrs: {
                                                          errorClass:
                                                            "errorMargin",
                                                          id: "Password",
                                                          inputClass:
                                                            "signwidthInput customSignText",
                                                          name: "Password",
                                                          type: "password",
                                                          placeholder:
                                                            "Password",
                                                          errors: touched
                                                            ? errors
                                                            : [],
                                                          isIcon: false,
                                                        },
                                                        model: {
                                                          value: _vm.password,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.password = $$v
                                                          },
                                                          expression:
                                                            "password",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _c("ValidationProvider", {
                                            staticClass: "w-full",
                                            attrs: {
                                              name: "Confirm password",
                                              rules:
                                                "required|password:@Password",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({
                                                    errors,
                                                    touched,
                                                  }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        attrs: {
                                                          errorClass:
                                                            "errorMargin",
                                                          inputClass:
                                                            "signwidthInput customSignText",
                                                          id: "Confirm password",
                                                          name: "Confirm password",
                                                          type: "password",
                                                          placeholder:
                                                            "Confirm your password",
                                                          errors: touched
                                                            ? errors
                                                            : [],
                                                          isIcon: false,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.confirmPassword,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.confirmPassword =
                                                              $$v
                                                          },
                                                          expression:
                                                            "confirmPassword",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "submit-wrapper mt-7" },
                                        [
                                          _c("UiButton", {
                                            attrs: {
                                              variant: "black",
                                              type: "submit",
                                              buttonClasses:
                                                "customPadding fontButton",
                                              disabled:
                                                invalid ||
                                                !dirty ||
                                                _vm.euniceValidator,
                                              processing: _vm.loading,
                                              buttonText: "Continue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3277880877
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.companySignUp && _vm.talentInitial
                ? _c(
                    "div",
                    [
                      _c("h3", { staticClass: "welcomeText welcomeTextBig" }, [
                        _vm._v("Welcome to ProveraCare"),
                      ]),
                      _c(
                        "h5",
                        { staticClass: "subTextRegister text-center mb-4" },
                        [_vm._v("Sign up as Talent")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass:
                            "text-base font-normal leading-6 font-outfit mb-4 text-center",
                        },
                        [_vm._v(" To get started please provide your email ")]
                      ),
                      _c("ValidationObserver", {
                        staticClass: "flex flex-col overflow-hidden",
                        attrs: { tag: "div" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ invalid }) {
                                return [
                                  _c("ValidationProvider", {
                                    staticClass: "w-full",
                                    attrs: {
                                      name: "Email address",
                                      rules:
                                        "c_email|required|is-email-registered",
                                      immediate: _vm.prepopulated,
                                      debounce: 500,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors, touched }) {
                                            return [
                                              _c("FormGroup", {
                                                attrs: {
                                                  errorClass: "errorMargin",
                                                  id: "username",
                                                  name: "Email address",
                                                  inputClass:
                                                    "signwidthInput customSignText",
                                                  type: "email",
                                                  placeholder:
                                                    "example@email.com",
                                                  errors:
                                                    _vm.prepopulated || touched
                                                      ? errors
                                                      : [],
                                                  processing:
                                                    _vm.emailValidationPending,
                                                  isIcon: false,
                                                },
                                                model: {
                                                  value: _vm.email,
                                                  callback: function ($$v) {
                                                    _vm.email =
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                  },
                                                  expression: "email",
                                                },
                                              }),
                                              _vm.regexError
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "regex-error",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.regexError)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "submit-wrapper mt-7" },
                                    [
                                      _c("UiButton", {
                                        attrs: {
                                          variant: "black",
                                          buttonClasses:
                                            "customPadding fontButton",
                                          processing: _vm.loading,
                                          disabled: invalid,
                                          buttonText: "Continue",
                                        },
                                        on: { click: _vm.handleTalentInitial },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2447418400
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.consentTalent && !_vm.companySignUp && !_vm.talentInitial
                ? _c("div", { staticClass: "slideCompany slide-in-right" }, [
                    _c(
                      "h3",
                      {
                        staticClass:
                          "text-primary-black text-xl font-normal mb-4",
                      },
                      [_vm._v(" Consent Notice ")]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-sm font-normal mb-6 text-sm" },
                      [
                        _vm._v(
                          " By accessing or using the ProveraCare Site and services, you expressly consent to the collection, use, and disclosure of your personal and health information in accordance with our Privacy Policy and applicable laws. "
                        ),
                      ]
                    ),
                    _vm._m(2),
                    _c(
                      "div",
                      { staticClass: "flex items-start flex-col gap-2 mt-6" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "text-sm",
                            attrs: { for: "consentCheckbox" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.consentChecked,
                                  expression: "consentChecked",
                                },
                              ],
                              staticClass: "mt-1",
                              attrs: {
                                type: "checkbox",
                                id: "consentCheckbox",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.consentChecked)
                                  ? _vm._i(_vm.consentChecked, null) > -1
                                  : _vm.consentChecked,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.consentChecked,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.consentChecked = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.consentChecked = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.consentChecked = $$c
                                  }
                                },
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "icon-checked",
                                staticStyle: { display: "inline-block" },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "11",
                                      height: "9",
                                      viewBox: "0 0 11 9",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                                        fill: "white",
                                        stroke: "white",
                                        "stroke-width": "0.3",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._m(3),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "submit-wrapper mt-7" },
                          [
                            _c("UiButton", {
                              attrs: {
                                variant: "black",
                                buttonClasses:
                                  "customPadding fontButtonConsent",
                                processing: _vm.loading,
                                disabled: !_vm.consentChecked || _vm.invalid,
                                buttonText: "Continue",
                              },
                              on: { click: _vm.handleSecondStepTalent },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              !_vm.companySignUp && !_vm.consentTalent && !_vm.talentInitial
                ? _c(
                    "div",
                    { staticClass: "slideCompany slide-in-right" },
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "welcomeText welcomeTextSmall text-center",
                        },
                        [_vm._v(" Create your account ")]
                      ),
                      _c(
                        "h5",
                        { staticClass: "subTextRegister text-center mb-4" },
                        [
                          _vm._v(
                            " Just a few more things before you're ready! "
                          ),
                        ]
                      ),
                      _c("ValidationObserver", {
                        ref: "observer",
                        staticClass: "flex flex-col overflow-hidden",
                        attrs: { tag: "div" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ invalid, dirty, handleSubmit }) {
                                return [
                                  _c(
                                    "form",
                                    {
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                          return handleSubmit(_vm.submit)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-col customGap",
                                        },
                                        [
                                          _c("ValidationProvider", {
                                            staticClass: "w-full",
                                            attrs: {
                                              name: "Preferred name",
                                              rules: "required|c_name",
                                              immediate: _vm.prepopulated,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({
                                                    errors,
                                                    touched,
                                                  }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        attrs: {
                                                          id: "givenName",
                                                          errorClass:
                                                            "errorMargin",
                                                          inputClass:
                                                            "signwidthInput customSignText",
                                                          name: "Preferred name",
                                                          placeholder:
                                                            "Preferred name",
                                                          errors:
                                                            _vm.prepopulated ||
                                                            touched
                                                              ? errors
                                                              : [],
                                                          isIcon: false,
                                                        },
                                                        model: {
                                                          value: _vm.givenName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.givenName =
                                                              typeof $$v ===
                                                              "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                          },
                                                          expression:
                                                            "givenName",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _c("ValidationProvider", {
                                            staticClass: "w-full",
                                            attrs: {
                                              name: "Last name",
                                              rules: "required|c_name",
                                              immediate: _vm.prepopulated,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({
                                                    errors,
                                                    touched,
                                                  }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        attrs: {
                                                          id: "familyName",
                                                          errorClass:
                                                            "errorMargin",
                                                          inputClass:
                                                            "signwidthInput customSignText",
                                                          name: "Last name",
                                                          placeholder:
                                                            "Last name",
                                                          errors:
                                                            _vm.prepopulated ||
                                                            touched
                                                              ? errors
                                                              : [],
                                                          isIcon: false,
                                                        },
                                                        model: {
                                                          value: _vm.familyName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.familyName =
                                                              typeof $$v ===
                                                              "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                          },
                                                          expression:
                                                            "familyName",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _c("ValidationProvider", {
                                            staticClass: "w-full",
                                            attrs: {
                                              name: "Password",
                                              rules: "password_len|required",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({
                                                    errors,
                                                    touched,
                                                  }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        attrs: {
                                                          inputClass:
                                                            "signwidthInput customSignText",
                                                          id: "Password",
                                                          errorClass:
                                                            "errorMargin",
                                                          name: "Password",
                                                          type: "password",
                                                          placeholder:
                                                            "Password",
                                                          errors: touched
                                                            ? errors
                                                            : [],
                                                          isIcon: false,
                                                        },
                                                        model: {
                                                          value: _vm.password,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.password = $$v
                                                          },
                                                          expression:
                                                            "password",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _c("ValidationProvider", {
                                            staticClass: "w-full",
                                            attrs: {
                                              name: "Confirm password",
                                              rules:
                                                "required|password:@Password",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({
                                                    errors,
                                                    touched,
                                                  }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        attrs: {
                                                          inputClass:
                                                            "signwidthInput customSignText",
                                                          id: "Confirm password",
                                                          errorClass:
                                                            "errorMargin",
                                                          name: "Confirm password",
                                                          type: "password",
                                                          placeholder:
                                                            "Confirm your password",
                                                          errors: touched
                                                            ? errors
                                                            : [],
                                                          isIcon: false,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.confirmPassword,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.confirmPassword =
                                                              $$v
                                                          },
                                                          expression:
                                                            "confirmPassword",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "submit-wrapper mt-7" },
                                        [
                                          _c("UiButton", {
                                            attrs: {
                                              variant: "black",
                                              type: "submit",
                                              buttonClasses:
                                                "customPadding fontButton",
                                              disabled:
                                                invalid ||
                                                !dirty ||
                                                _vm.euniceValidator,
                                              processing: _vm.loading,
                                              buttonText: "Continue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3545883894
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.consentComapny && !_vm.consentTalent
                ? _c(
                    "div",
                    {
                      staticClass:
                        "legal text-black text-sm text-center font-normal mt-4",
                    },
                    [
                      _vm._v(" By continuing, you agree to ProveraCare;"),
                      _c("br"),
                      _c("AuthFormLink", {
                        staticClass: "inline text-xs",
                        attrs: {
                          text: "Conditions of Use",
                          external: "",
                          small: "",
                          link: _vm.termsAndCondsURL,
                        },
                      }),
                      _vm._v(" and "),
                      _c("AuthFormLink", {
                        staticClass: "inline text-sm",
                        attrs: {
                          text: "Privacy Notice",
                          external: "",
                          small: "",
                          link: _vm.privacyPolicyURL,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.errorMessage
                ? _c("div", { staticClass: "error-msg" }, [
                    _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
                  ])
                : _vm._e(),
              _vm.successMessage
                ? _c("div", { staticClass: "success-msg text-green-500" }, [
                    _vm._v(" " + _vm._s(_vm.successMessage) + " "),
                  ])
                : _vm._e(),
              _vm._m(4),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "consentContainer" }, [
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("Who should sign this form?"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "• Authorized administrator of the healthcare‑provider organization (“Client”)."
            ),
          ]),
          _c("li", [
            _vm._v(
              "• Each staff member (“Resource”) invited to log into the ProveraCare platform."
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("Why we need your information"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "We collect and process your business contact details and login credentials so that your organization can:"
            ),
          ]),
          _c("li", [
            _vm._v(
              "• Schedule and document in‑home healthcare services on the ProveraCare platform."
            ),
          ]),
          _c("li", [
            _vm._v("• Generate visit notes, timesheets, and invoices."),
          ]),
          _c("li", [
            _vm._v(
              "• Comply with healthcare, privacy, and billing regulations."
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("What we collect about you (staff / resources)"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v("Name, job title, business email, and phone number."),
          ]),
          _c("li", [
            _vm._v(
              "User‑generated content such as visit notes or messages you enter."
            ),
          ]),
          _c("li", [
            _vm._v(
              "Technical usage data (IP address, device ID, session cookies)."
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("What patient information may appear in the platform?"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              " Patient personal and health information (PHI) is entered by authorized staff. Your organization confirms it has obtained all legally required consents or authorizations from patients before entering their PHI into ProveraCare. "
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("Who will see the information?"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "Authorized users in your organization who need it for care or operations."
            ),
          ]),
          _c("li", [
            _vm._v(
              "ProveraCare personnel with a need‑to‑know role (support, security)."
            ),
          ]),
          _c("li", [
            _vm._v(
              " Trusted sub‑processors providing secure cloud hosting, payment, or communication services — each bound by Business Associate / Data Processing Agreements. "
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [_vm._v("Cookies")]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "ProveraCare uses only essential session cookies for authentication and security. We do not use analytics or advertising cookies."
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("Your choices and rights"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "Request access, correction, or deletion of your personal data by emailing "
            ),
            _c(
              "a",
              {
                staticClass: "privacyLink",
                attrs: { href: "mailto:privacy@proveracare.com" },
              },
              [_vm._v("privacy@proveracare.com")]
            ),
            _vm._v("."),
          ]),
          _c("li", [
            _vm._v(
              "Withdraw consent at any time (this may suspend your platform login)."
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", [
      _c("b", [_vm._v("I understand and consent ")]),
      _vm._v("  to the collection, use, and sharing of my data  "),
      _c("u", [_vm._v("as described above")]),
      _vm._v(
        ". Practices and consent to the collection, use, and disclosure of your information as described above."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "consentContainer" }, [
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("Who should sign this form?"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "• Authorized administrator of the healthcare‑provider organization (“Client”)."
            ),
          ]),
          _c("li", [
            _vm._v(
              "• Each staff member (“Resource”) invited to log into the ProveraCare platform."
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("Why we need your information"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "We collect and process your business contact details and login credentials so that your organization can:"
            ),
          ]),
          _c("li", [
            _vm._v(
              "• Schedule and document in‑home healthcare services on the ProveraCare platform."
            ),
          ]),
          _c("li", [
            _vm._v("• Generate visit notes, timesheets, and invoices."),
          ]),
          _c("li", [
            _vm._v(
              "• Comply with healthcare, privacy, and billing regulations."
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("What we collect about you (staff / resources)"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v("Name, job title, business email, and phone number."),
          ]),
          _c("li", [
            _vm._v(
              "User‑generated content such as visit notes or messages you enter."
            ),
          ]),
          _c("li", [
            _vm._v(
              "Technical usage data (IP address, device ID, session cookies)."
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("What patient information may appear in the platform?"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              " Patient personal and health information (PHI) is entered by authorized staff. Your organization confirms it has obtained all legally required consents or authorizations from patients before entering their PHI into ProveraCare. "
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("Who will see the information?"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "Authorized users in your organization who need it for care or operations."
            ),
          ]),
          _c("li", [
            _vm._v(
              "ProveraCare personnel with a need‑to‑know role (support, security)."
            ),
          ]),
          _c("li", [
            _vm._v(
              " Trusted sub‑processors providing secure cloud hosting, payment, or communication services — each bound by Business Associate / Data Processing Agreements. "
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [_vm._v("Cookies")]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "ProveraCare uses only essential session cookies for authentication and security. We do not use analytics or advertising cookies."
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "fontTitle" }, [
        _vm._v("Your choices and rights"),
      ]),
      _c("div", { staticClass: "consentList mb-4" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "Request access, correction, or deletion of your personal data by emailing "
            ),
            _c(
              "a",
              {
                staticClass: "privacyLink",
                attrs: { href: "mailto:privacy@proveracare.com" },
              },
              [_vm._v("privacy@proveracare.com")]
            ),
            _vm._v("."),
          ]),
          _c("li", [
            _vm._v(
              "Withdraw consent at any time (this may suspend your platform login)."
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", [
      _c("b", [_vm._v("I understand and consent ")]),
      _vm._v("  to the collection, use, and sharing of my data  "),
      _c("u", [_vm._v("as described above")]),
      _vm._v(
        ". Practices and consent to the collection, use, and disclosure of your information as described above."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "flex flex-row mt-7 resend jutify-center items-center" },
      [
        _vm._v(" Already a member? "),
        _c(
          "a",
          {
            staticClass:
              "ml-1 mr-1 hover:underline router-link-exact-active router-link-active",
            attrs: { href: "/signin" },
          },
          [
            _c(
              "span",
              {
                staticClass:
                  "font-normal text-lg text-default-500 hover:text-primary-500 flex flex-row blueText items-center cursor-pointer gap-2",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-row text-center nameBlue hover:underline",
                  },
                  [_vm._v(" Sign in ")]
                ),
              ]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }